<template>
  <div
    class="all"
    :style="{ 'background-image': 'url(' + info.image + ')'}"
    data-aos="fade-up"
    data-aos-duration="2000"
  >
    <div class="flou flex items-end h-full">
      <div class="w-full p-6">
        <div class="nom">
          {{ info.name }}
        </div>
        <div class="role">
          {{ info.role }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.all{
  //background-image: url("../../../assets/images/jpg/moudilou.jpg");
  height: 417px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.flou{
  background: rgba(13, 23, 52, 0.5);
  color: $white;
  display: none;
}
.nom{
  font-weight: 600;
  font-size: 32px;
  line-height: 170%;
  letter-spacing: 0.01em;
}
.role{
  font-weight: normal;
  font-size: 18px;
  line-height: 160%;
}
.all:hover{
  .flou{
    display: flex;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .all{
    //background-image: url("../../../assets/images/jpg/moudilou.jpg");
    height: 350px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>
